export default "__VITE_ASSET__gM9HntVl__"